import { PLAID_LINK_ORIGINS } from 'features/plaid/constants/PlaidLinkOrigins';
import { PlaidMarketingConsentEntryPoint } from 'features/plaid/hooks/useHasPlaidMarketingConsent';

export const PLAID_RELINK_SOURCE_NAMES = {
  AccountDetails: 'account_details_relink',
  MoveMoneyTransfer: 'move_money_relink',
} as const;

export type PlaidRelinkSourceName =
  (typeof PLAID_RELINK_SOURCE_NAMES)[keyof typeof PLAID_RELINK_SOURCE_NAMES];

export type PlaidLinkSourceName =
  (typeof PLAID_LINK_ORIGINS)[PlaidMarketingConsentEntryPoint]['sourceName'];

/** Every Data-approved `source_name` a surface may report to analytics. */
export type PlaidSourceName = PlaidLinkSourceName | PlaidRelinkSourceName;
